import ReactBarcode from 'react-barcode';

import { TEST_IDS } from 'commons';
import { Accordion, Product } from 'components';
import { Entry } from 'types';

import * as S from './styles';

interface Props {
  entries: Entry[];
  hideCopyButton?: boolean;
  defaultOpen?: boolean;
}

export function Products({
  entries,
  hideCopyButton = false,
  defaultOpen = true,
}: Props) {
  const renderProducts = entries.map((entry: Entry, index: number) => {
    const { ean } = entry.product;

    return (
      <Product key={index} entry={entry} hideCopyButton={hideCopyButton}>
        <ReactBarcode
          format="EAN13"
          value={ean}
          height={50}
          fontSize={12}
          font="Montserrat"
          width={2}
          margin={0}
        />
      </Product>
    );
  });

  return (
    <Accordion title="Produtos" defaultOpen={defaultOpen}>
      <S.Main data-testid={TEST_IDS.CONSIGNMENT_ITEMS_LIST}>
        {renderProducts}
      </S.Main>
    </Accordion>
  );
}
